module.exports = __webpack_public_path__ + "img/bsidd-2.8c3c2fdd.jpg";